module.exports = __webpack_public_path__ + "r-v3/img/virtual_background_outside_02.191f3b44.jpg";